export default "__VITE_ASSET__5c98d214__"